import { MutationTree } from "vuex";
import { IIdomSettingsStateInterface } from "./state";
import { ISettingsItemGroup } from "src/modules/idom-settings/models/settings";

const mutation: MutationTree<IIdomSettingsStateInterface> = {
  setSettings(state, payload: ISettingsItemGroup[]) {
    state.settings = payload;
  },
};

export default mutation;
